import constants from '@/api';

const initialState = () => ({
	fileMetaEditorDialog: false,
	fileMeta: {},
	selectedFileMeta: {},
});
export default {
	namespaced: true,
	state: initialState(),
	mutations: {
		openFileMetaDialog(state) {
			state.fileMetaEditorDialog = true;
		},
		closeFileMetaDialog(state) {
			state.fileMetaEditorDialog = false;
		},
		loadFileMeta(state, mm) {
			state.fileMeta = JSON.parse(JSON.stringify(mm));
		},
		setSelectedFileMeta(state, sf) {
			state.selectedFileMeta = sf;
		},
		setCurrentLogs(state, logs) {
			state.currentLogs = logs;
		},
		refreshStockistListEmitter(state) {},
		failure: (s, msg) => {
			console.log('[failure] ', msg);
		},
		resetState(state) {
			const initial = initialState();
			Object.keys(initial).forEach(key => {
				state[key] = initial[key];
			});
		},
	},
	actions: {
		getFileMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: payload,
					url: constants.FILE_META_BY_STOCKIST,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						commit('loadFileMeta', data.metas);
						return data;
					} else {
						fail(data.message || 'Failed to load Mail meta');
						return false;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
	},
	getters: {
		fileMetaEditorDialog: state => state.fileMetaEditorDialog,
		fileMeta: state => state.fileMeta,
		selectedFileMeta: state => state.selectedFileMeta,
	},
};
